import React, { useMemo } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { toRichTextQuestionAnswer } from '../../stores/QuestionStore';
import { DisplayMode } from '../RenderForm';
import { AsyncEditRichTextParagraph } from './edit/edit-rich-text-paragraph';
import { ViewRichTextParagraph } from './view/ViewRichTextParagraph';
export const RichTextParagraph = observer(({
  id,
  questionStore,
  displayMode
}) => {
  const richTextValue = toJS(toRichTextQuestionAnswer(questionStore.currentAnswer));
  const showEditComponent = displayMode === DisplayMode.Edit && !(getBooleanFF('platform.proforma-read-only-questions.wewrsr') && questionStore.formQuestion.readOnly);

  //We pass a cloned 'richTextValue' to avoid the mutation by AsyncEditRichTextParagraph component
  const richTextValueCloned = useMemo(() => cloneDeep(richTextValue), [richTextValue]);
  if (showEditComponent) {
    return /*#__PURE__*/React.createElement(AsyncEditRichTextParagraph, {
      id: id,
      value: richTextValueCloned,
      isInvalid: !!questionStore.validationErrors,
      onChange: answer => {
        if (!isEqual(richTextValue, answer)) {
          questionStore.setAnswer(answer);
        }
      }
    });
  }
  return /*#__PURE__*/React.createElement(ViewRichTextParagraph, {
    id: id,
    value: richTextValue,
    displayMode: displayMode
  });
});